import {HttpExclude, PageCollection, Resource} from 'simpli-web-sdk'
import {TipoCliente} from '@/model/resource/TipoCliente'

export class PanelUserType extends Resource {
  idPanelUserTypePk: number = 0
  description: String | null = null
  get $id() {
    return this.idPanelUserTypePk
  }
  set $id(val) {
    this.idPanelUserTypePk = val
  }
  get $tag() {
    return String(this.description)
  }
  set $tag(val) {
    this.description = val
  }
}
